module.exports = __webpack_public_path__ + "img/icon-general-object.bcabe492.svg";